import { LookupBase } from '../models/utils/lookup-base.model';

export enum CampaignsManagementIssuesStatus {
  posted = 'posted',
  reopened = 'reopened',
  resolved = 'resolved',
  closed = 'closed',
}

export const CAMPAIGNS_MANAGEMENT_ISSUES_STATUS_LOOKUP: LookupBase[] = [
  { value: CampaignsManagementIssuesStatus.posted, description: 'Posted', cssClass: 'bg-warning text-dark' },
  { value: CampaignsManagementIssuesStatus.reopened, description: 'Reopened', cssClass: 'bg-secondary' },
  { value: CampaignsManagementIssuesStatus.resolved, description: 'Resolved', cssClass: 'bg-success' },
  { value: CampaignsManagementIssuesStatus.closed, description: 'Closed', cssClass: 'bg-danger' },
];
